<template>
  <div class="business-team ">
    <div class="module-item-style" v-if="role">
      <div class="module-item-title-border-left">注册</div>
      <el-form class="business-team-form" ref="teamForm" :model="teamForm" label-width="130px">
        <el-form-item label="团队/公司名称">
          <el-input v-model="teamForm.name"></el-input>
        </el-form-item>
        <el-form-item label="团队/公司简介">
          <el-input type="textarea" rows="5" v-model="teamForm.sortname" maxlength="30"
                    show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="所属行业">
          <el-select v-model="teamForm.industry" placeholder="请选择所属行业">
            <el-option v-for="(item,i) in industryList" :label="item.value" :value="item.id" :key="i">{{item.value}}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveForm">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="no-auth-view module-item-style" v-else>
      只有超级管理员可查看
    </div>

  </div>
</template>

<script>
  export default {
    name: 'business-team',
    data() {
      return {
        teamForm:{
          name:'',
          sortname:'',
          industry:''
        },
        industryList:[],
      }
    },
    created(){
      this.getTeamInfo()
    },
    computed:{
      role(){
        let serviceRole = this.$store.state.user.roles
        if(serviceRole == 0){
          return true
        }else {
          return  false
        }
      },
    },
    mounted() {

    },
    methods: {
      getTeamInfo(){
        this.$http.getTeamInfoAPI().then( res => {
          if(res.status == 1){
            this.teamForm.name = res.data.c_name
            this.teamForm.sortname = res.data.sortname
            this.teamForm.industry = res.data.industryId.toString()
            let arr = [
              {
                id:'0',
                value:'——请选择——'
              }
            ];
            let obj = res.data.industry_select
            for(var key in obj){
              if(!obj.hasOwnProperty(key)){
                continue;
              }
              var item = {};
              item.id = key;
              item.value = obj[key];
              arr.push(item);
            }
            this.industryList = arr
          }
        })
      },
      saveForm(){
        if(this.$utils.u_isEmpty(this.teamForm.name)){
          this.$message({
            message:' 请填写团队/公司名称',
            type: 'error'
          })
          return false
        }
        if(this.$utils.u_isEmpty(this.teamForm.sortname)){
          this.$message({
            message:' 请填写团队/公司简介',
            type: 'error'
          })
          return false
        }
        if(this.$utils.u_isEmpty(this.teamForm.industry)){
          this.$message({
            message:' 请选择所属行业',
            type: 'error'
          })
          return false
        }
        this.$http.saveTeamInfoAPI(this.teamForm).then(res => {
          if(res.status == 1){
            this.$message({
              message:res.msg,
              type: 'success'
            })
          }else {
            this.$message({
              message:res.msg,
              type: 'error'
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .business-team{
    padding-top: 15px;
    .business-team-form{
      width: 400px;
      padding-top: 20px;
      .el-input__inner{
        width: 273px;
      }
    }
  }

</style>
